export default __webpack_public_path__ + "static/media/evennumbers_locked_crown.5a9b49ea.svg";